var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoostIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.102,
    x2: 0,
    y2: 0.91,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e87f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f68a6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.272,
    y1: -0.092,
    x2: -0.288,
    y2: 1.121,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1377",
    "data-name": "Groupe 1377",
    transform: "translate(-142 -1465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_120",
    "data-name": "Trac\\xE9 120",
    d: "M1346.391-154.923a23.527,23.527,0,0,1-23.5-23.5,23.527,23.527,0,0,1,23.5-23.5,23.527,23.527,0,0,1,23.5,23.5A23.527,23.527,0,0,1,1346.391-154.923Zm0-45a21.524,21.524,0,0,0-21.5,21.5,21.524,21.524,0,0,0,21.5,21.5,21.525,21.525,0,0,0,21.5-21.5A21.525,21.525,0,0,0,1346.391-199.923Z",
    transform: "translate(-1180.891 1666.923)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_126",
    "data-name": "Trac\\xE9 126",
    d: "M25.406,3.619a5.391,5.391,0,0,0-7.624,0L13.415,7.986a1.26,1.26,0,0,0-.186-.079L8.22,6.237a1.25,1.25,0,0,0-1.279.3l-4.59,4.59a1.25,1.25,0,0,0,.366,2.022l4.361,1.985a1.431,1.431,0,0,0,.407.814l5.592,5.591a1.43,1.43,0,0,0,.814.407l1.985,4.361a1.25,1.25,0,0,0,2.022.366l4.59-4.59a1.25,1.25,0,0,0,.3-1.279L21.118,15.8a1.28,1.28,0,0,0-.079-.186l4.367-4.367A5.391,5.391,0,0,0,25.406,3.619ZM16.061,20.683q-.015-.032-.031-.064l3.045-3.046,1.1,3.289L17.4,23.632ZM8.406,13,11.451,9.95l-3.289-1.1L5.393,11.622l2.949,1.342ZM20.11,4.95a2.892,2.892,0,0,1,3.965,3.965ZM18.281,6.656,10,14.933l4.088,4.088,8.277-8.277ZM11.226,21.108a1.25,1.25,0,0,1,0,1.768L9.139,24.964A1.25,1.25,0,1,1,7.371,23.2l2.087-2.087A1.25,1.25,0,0,1,11.226,21.108Zm-3.75-.732a1.25,1.25,0,0,0-1.768-1.768L3.62,20.7a1.25,1.25,0,0,0,1.768,1.768Z",
    transform: "translate(151.016 1473.961)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostIcon);
export default __webpack_public_path__ + "static/media/BoostIcon.34bc4b5a3b0605d4f361407e17fb2ce0.svg";
export { ForwardRef as ReactComponent };